module.exports = __webpack_public_path__ + "img/poster-1.ff454746.png";